<template>
  <ul class="status">
    <li v-for="role in roles" :key="role.id">
      <checkbox :value="role.id" name="roles" v-model="val" color="#000000">{{
        role.title
      }}</checkbox>
    </li>
  </ul>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "Role",
  props: {
    value: {
      default: function () {
        return [];
      },
    },
  },
  computed: {
    ...mapState(["roles"]),
    val: {
      get() {
        let val = [];
        if (this.value && this.value.length) {
          for (let i = 0; i < this.value.length; i++) {
            if (this.value[i].id) {
              val.push(this.value[i].id);
            }
          }
        }
        return val;
      },
      set(val) {
        let result;
        result = [];
        for (let i = 0; i < val.length; i++) {
          if (this.roles[val[i]]) {
            result.push(this.roles[val[i]]);
          }
        }
        this.$emit("input", result);
      },
    },
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    regionChange(e) {
      this.regionId = e.target.value;
      if (this.regionId && this.regionId > 0) {
        this.cities = this.location[this.regionId].child;
      } else {
        this.cities = [];
        this.$emit("input", null);
      }
    },
  },
};
</script>
<style lang="scss">
.location {
  select {
    padding: 5px 5px;
    width: 100%;
    height: 34px;
    border-radius: 10px;
    margin-bottom: 15px;
  }
}
</style>
